import type { DefaultEvents, Emitter } from 'nanoevents';
import { emulateTab } from 'emulate-tab';
import { InputActions } from '@game-libs/models';

export const setupDomNavigation = (
  inputEvents: Emitter<DefaultEvents>
): void => {
  inputEvents.on<InputActions>(InputActions.MOVE_RIGHT, () => {
    if (emulateTab.findSelectableElements().length > 0) {
      const focusedElement: HTMLElement = document.activeElement as HTMLElement;
      if (
        !(
          focusedElement.localName === 'input' &&
          (focusedElement as HTMLInputElement).type === 'range'
        )
      ) {
        emulateTab.forwards();
      }
    }
  });
  inputEvents.on<InputActions>(InputActions.MOVE_DOWN, () => {
    if (emulateTab.findSelectableElements().length > 0) {
      emulateTab.forwards();
    }
  });
  inputEvents.on<InputActions>(InputActions.MOVE_LEFT, () => {
    if (emulateTab.findSelectableElements().length > 0) {
      const focusedElement: HTMLElement = document.activeElement as HTMLElement;
      if (
        !(
          focusedElement.localName === 'input' &&
          (focusedElement as HTMLInputElement).type === 'range'
        )
      ) {
        emulateTab.backwards();
      }
    }
  });
  inputEvents.on<InputActions>(InputActions.MOVE_UP, () => {
    if (emulateTab.findSelectableElements().length > 0) {
      emulateTab.backwards();
    }
  });
  inputEvents.on<InputActions>(
    InputActions.SELECT,
    (actionArgs: KeyboardEvent) => {
      if (
        actionArgs.code !== 'Enter' &&
        actionArgs.code !== 'Space' &&
        document.activeElement?.localName === 'button'
      ) {
        const button = document.activeElement as HTMLButtonElement;
        button?.click();
      }

      if (
        actionArgs.code !== 'Space' &&
        document.activeElement?.localName === 'input'
      ) {
        const input = document.activeElement as HTMLInputElement;
        input?.click();
      }
    }
  );
};
